import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-cbm-info',
    templateUrl: './cbm-info.component.html',
    styleUrls: ['./cbm-info.component.scss'],
    standalone: false
})
export class CbmInfoComponent implements OnInit {
  @Input() title: string;
  @Input() information: string;
  @Input() cbmRefNo: string;
  @Input() positiveButton: string;

  constructor(
    public activeModal: NgbActiveModal
    ) { }

  ngOnInit() {
  }

}
